import React from 'react';

function NotFound() {
    return (
        <div className='container py-5 mb-5'>
            <div className='row justify-content-center text-center'>
                <div className='col-12 col-md-8'>
                    <h1 className='mt-4'>404 Not Found</h1>
                    <p className='mb-4'>
                        Sorry, the page you are looking for does not exist.
                    </p>
                    
                </div>
            </div>
        </div>
    );
}

export default NotFound;
